import type { Category } from '@/app/format';

interface Rule { test: RegExp; category: Category; weight: number; }

/**
 * Keyword → category mapping. Higher weight wins on multiple matches.
 * Seeded from the v1 factory data and common SA merchant strings.
 */
const RULES: Rule[] = [
  // Fixed Hard Costs
  { test: /sbsavaf|asset finance|vehicle finance|car finance|vw finance|bmw finance|merc.*finance/i, category: 'Fixed Hard Costs',     weight: 10 },
  { test: /autogen|insurance|outsurance|santam|old mutual/i,                                       category: 'Fixed Hard Costs',     weight: 9  },
  { test: /\brent\b|landlord|propay/i,                                                             category: 'Fixed Hard Costs',     weight: 9  },
  { test: /vodacom|mtn|telkom|cell c|rain mobile|fibre|adsl/i,                                    category: 'Fixed Hard Costs',     weight: 7  },

  // Services & Safety
  { test: /cartrack|netstar|tracker|panic button|armed response/i,                                category: 'Services & Safety',    weight: 10 },
  { test: /security|adt|chubb|bidvest protea/i,                                                    category: 'Services & Safety',    weight: 8  },

  // Living Allocations
  { test: /checkers|shoprite|pick ?n ?pay|pnp|woolworths|spar|food lover/i,                        category: 'Living Allocations',   weight: 8  },
  { test: /engen|shell|bp |caltex|sasol|fuel|petrol/i,                                             category: 'Living Allocations',   weight: 9  },
  { test: /uber|bolt|taxify|inDrive/i,                                                             category: 'Living Allocations',   weight: 9  },
  { test: /prepaid|airtime|data bundle/i,                                                          category: 'Living Allocations',   weight: 6  },
  { test: /electricity|eskom|prepaid (electric|meter)/i,                                           category: 'Living Allocations',   weight: 9  },
  { test: /water|municipal/i,                                                                      category: 'Living Allocations',   weight: 7  },

  // Subscriptions & Caps
  { test: /netflix|showmax|amazon prime|disney|youtube premium|spotify|apple music|google play|apple\.com/i, category: 'Subscriptions & Caps', weight: 9  },
  { test: /kfc|pedros|steers|chicken ?licken|nando|debona|mcdonald|burger king|wicked wings/i,    category: 'Subscriptions & Caps', weight: 8  },
  { test: /movies|ster ?kinekor|nu metro|cine|iwin|playstation|xbox/i,                             category: 'Subscriptions & Caps', weight: 8  },

  // Debt Paydown
  { test: /\btfg\b|foschini|markham|jet|exact|@home/i,                                            category: 'Debt Paydown',         weight: 10 },
  { test: /\bdion\s*wired\b|game( |$)|makro|hi-?fi\s*corp/i,                                      category: 'Debt Paydown',         weight: 10 },
  { test: /\bcapitec\s*credit\b|personal loan|wesbank|mfc|tymecredit/i,                            category: 'Debt Paydown',         weight: 8  },
];

/** Apply the rule table to a description. Returns null if no rule matches. */
export function categorize(description: string): Category | null {
  let best: { category: Category; weight: number } | null = null;
  for (const r of RULES) {
    if (r.test.test(description)) {
      if (!best || r.weight > best.weight) best = { category: r.category, weight: r.weight };
    }
  }
  return best ? best.category : null;
}

/** Common merchant normalisation for the suggestions engine. */
export function merchantKey(description: string): string {
  return description
    .toLowerCase()
    .replace(/\d{2,}[\/-]\d{2,}[\/-]?\d{0,4}/g, ' ')     // strip dates
    .replace(/[*#\d][^\s]*\d+[^\s]*/g, ' ')              // strip tokens that are mostly digits (refs)
    .replace(/[^a-z\s]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}
